/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import gradients from '../../../../utils/gradients';
import LockIcon from '@material-ui/icons/Lock';
import { Link as RouterLink } from "react-router-dom";
import { NetworkContext } from '../../../../context/NetworkContext';
import { SnackBarContext } from "../../../../context/SnackbarContext";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Divider,
  Link,
  Avatar
} from '@material-ui/core';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
   
  },
  card: {
    width: theme.breakpoints.values.sm,
    maxWidth: '100%',
    overflow: 'unset',
    display: 'flex',
    
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  },
  content: {
    padding: theme.spacing(8, 4, 8, 4)
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    color: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  icon: {
    backgroundImage: gradients.green,
    color: theme.palette.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'absolute',
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32
  },
  loginForm: {

  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  person: {
    display: 'flex'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  fields: {
    margin: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButton: {
    marginTop: theme.spacing(4),
    width: '100%'
  }
}));

const LoginForm = props => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const history = useHistory();

  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  useEffect(() => {
    if(localStorage.getItem('token'))
    {
     history.push('/dashboard')

    }
    // const errors = validate(formState.values, schema);

    // setFormState(formState => ({
    //   ...formState,
    //   isValid: errors ? false : true,
    //   errors: errors || {}
    // }));
  }, [formState.values]);

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
     //dispatch(login());
     updateuser()
  };
  async function updateuser()
  {
    let bodycontent = {}
    if(formState.values)
    {
      
      bodycontent['username'] = formState.values.username;
        bodycontent['password'] = formState.values.password;
        bodycontent['id'] = formState.values.id;
       let masterroles_arr = await sendNetworkRequest('/auth/employeelogin', {}, bodycontent,false)
       if(masterroles_arr && masterroles_arr.statusCode == 200)
       {
       
        let roles_array = []
        let rolename = ''
        if(masterroles_arr && masterroles_arr.user && masterroles_arr.user.roles)
        {
          masterroles_arr.user.roles.forEach(element => {
            if(element.master_role && element.master_role.role_accesses)
            {
              rolename = element.master_role.name
              element.master_role.role_accesses.forEach(accesselement => {

              roles_array =  roles_array.concat(accesselement.access_repo)
              });
            }
            
          });
        }
        localStorage.setItem('name', masterroles_arr?.user?.name);
        localStorage.setItem('role',rolename);
        localStorage.setItem('token', masterroles_arr.token);
        localStorage.setItem('access', roles_array);
        history.push('/dashboard')

       }else{
        snackbarCtx.setSnack({
          ...snackbarCtx,
          open: true,
          type: "error"  ,
          msg: masterroles_arr?.message??"Check your username and password",
          vertical: "top",
        });
       }
    }
  }
  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Typography
          gutterBottom
          variant="h3"
        >
        Log in 
        </Typography>
        <Typography variant="subtitle2">
        Sign in to Mookambika Backoffice
        </Typography>
        <form
          {...rest}
          className={clsx(classes.root, className)}
          onSubmit={handleSubmit}
        >
          <div className={classes.fields}>
            <TextField
              error={hasError('username')}
              fullWidth
              helperText={hasError('username') ? formState.errors.email[0] : null}
              label="Username"
              name="username"
              autoComplete="off"
              onChange={handleChange}
              value={formState.values.username || ''}
              variant="outlined"
            />
            <TextField
              error={hasError('password')}
              fullWidth
              helperText={
                hasError('password') ? formState.errors.password[0] : null
              }
              label="Password"
              name="password"
              onChange={handleChange}
              type="password"
              value={formState.values.password || ''}
              variant="outlined"
            />

          <Button
            className={classes.submitButton}
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            // component={RouterLink}
            
            // to={'/dashboard'}

          >
        Sign in
          </Button>
          </div>
          
        </form>
       
      </CardContent>
     
    </Card>
  );
};

LoginForm.propTypes = {
  className: PropTypes.string
};

export default LoginForm;
